import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
export function ProblemSection() {
  const problems = ['¿Dejaste de invitar gente a casa por vergüenza al "qué dirán"?', '¿Vivís lavando sábanas a las 3 de la mañana en silencio para no despertar a nadie?', '¿Ya probaste lavandina, vinagre y piedras caras y el olor vuelve en 48 horas?', '¿Sentís que tu gato se está "vengando" de vos?'];
  return <section className="w-full bg-[#FAFAF7] py-10 md:py-20 px-6" data-id="element-379">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto" data-id="element-380">
        <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-[#1C1C1C] mb-8 text-center" data-id="element-381">
          Vivir con olor a orina de gato te roba la libertad
        </h2>

        <div className="space-y-4 mb-12" data-id="element-382">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex items-start gap-3 bg-white p-4 rounded-lg" data-id="element-383">
              <XCircleIcon className="w-6 h-6 text-[#8B4513] flex-shrink-0 mt-1" data-id="element-384" />
              <p className="text-[#1C1C1C]" data-id="element-385">{problem}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="bg-[#E8F0E8] p-8 rounded-xl border border-[#2D8C5A]/20" data-id="element-386">
          <h3 className="font-['Playfair_Display'] text-2xl font-bold text-[#2D8C5A] mb-4" data-id="element-387">
            LA VERDAD REVELADA
          </h3>
          <p className="text-lg text-[#1C1C1C]/80 leading-relaxed" data-id="element-388">
            Tu gato no es "malo" y no se está vengando. Está comunicando estrés
            en el único idioma químico que conoce. Gritarle o refregarle la
            nariz solo empeora el problema porque aumenta su miedo. Necesitás
            dejar de atacar al gato y empezar a atacar la causa.
          </p>
        </motion.div>
      </motion.div>
    </section>;
}